import { ScrollArea } from '@/components/ui/scroll-area';
import { CloudRain, Droplets } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WeatherForecastSection = () => {
  const [forecast, setForecast] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchForecast = async () => {
    try {
      const response = await axios.get(`${API}/weather/forecast`);
      setForecast(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching weather forecast:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchForecast();
  }, []);

  const getWeatherIcon = (iconCode) => {
    return `https://openweathermap.org/img/wn/${iconCode}@2x.png`;
  };

  return (
    <div className="content-card" data-testid="weather-forecast-section">
      <div className="card-header">
        <h2>
          <CloudRain size={20} className="inline" /> 24-Hour Forecast - King's Lynn
        </h2>
      </div>
      <ScrollArea className="card-content">
        {loading ? (
          <p className="loading-text">Loading forecast...</p>
        ) : (
          <div className="weather-forecast-grid">
            {forecast.length > 0 ? (
              forecast.map((item, index) => (
                <div key={item.time} className="forecast-item" data-testid={`forecast-${index}`}>
                  <div className="forecast-time">{item.time}</div>
                  <img 
                    src={getWeatherIcon(item.icon)} 
                    alt={item.description} 
                    className="forecast-icon"
                  />
                  <div className="forecast-temp">{Math.round(item.temperature)}°C</div>
                  <div className="forecast-desc">{item.description}</div>
                  {item.precipitation > 0 && (
                    <div className="forecast-rain">
                      <Droplets size={14} />
                      <span>{item.precipitation}%</span>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p className="no-data">No forecast available</p>
            )}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

export default WeatherForecastSection;